import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, Grid, Typography, useTheme } from '@mui/material';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import { clearIcon, notClearIcon } from '../../../assets/icons';
import { PlayerIncidentList } from '../incidentsList.interface';
import { getInitials } from '../../../helpers/initialsExtractor';
import { dateTime } from '../../../time/datetime';
import { Avatar } from '../../../components/avatar/avatar';

interface IncidentPlayerListProps {
  incident: PlayerIncidentList;
}

export const IncidentPlayerList = ({ incident }: IncidentPlayerListProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Card sx={{ borderRadius: 4 }}>
      <CardHeader
        avatar={<Avatar title={getInitials(incident.playerName as string)} />}
        sx={{
          '&:hover': {
            cursor: 'pointer',
          },
        }}
        action={
          <Grid
            display="flex"
            alignItems="center"
            columnGap={1}
            textAlign="center"
          >
            {!incident.open ? (
              <>
                {clearIcon} {t('CLEAR')}
              </>
            ) : (
              <>
                {notClearIcon} {t('NOT_CLEAR')}
              </>
            )}
          </Grid>
        }
        title={incident.playerName}
        titleTypographyProps={{ variant: 'h6' }}
        subheaderTypographyProps={{ variant: 'subtitle2' }}
        subheader={
          <Grid display="flex" alignItems="center" columnGap={1}>
            <WatchLaterIcon
              sx={{ fontSize: '16px', fill: theme.palette.text.primary }}
            />
            <Typography color={theme.palette.text.primary}>
              {t('CREATED_ON', {
                createdDate: dateTime.format(
                  incident.createdAt,
                  t('common.datetime.FORMAT_SHORT_DATE'),
                ),
              })}
            </Typography>
          </Grid>
        }
      />
    </Card>
  );
};
